import React from "react";

const Mediation : React.FC = () => {
    return(
        <>
            Mediation
        </>
    )
}

export default Mediation